import script from "./AlojamientoView.vue?vue&type=script&setup=true&lang=js"
export * from "./AlojamientoView.vue?vue&type=script&setup=true&lang=js"

import "./AlojamientoView.vue?vue&type=style&index=0&id=33dbf2a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33dbf2a3"]])

export default __exports__